import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useWindowDimensions, sessionHelper } from "@utilities";
import { HeaderComponent, HeaderNavigatorComponent } from "@components";
import { PATH_HOME } from "@routes";
import { AppDispatch, selectCheckout, useAppSelector, useIsLoggedIn } from "@redux";
import { useDispatch } from "react-redux";
import { fetchActiveDiscount, fetchCartItems } from "./Checkout";
import { LoadingStage } from "src/Interfaces/shared";

export const HeaderModule = () => {
    // page hook
    const { width } = useWindowDimensions();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    // page states
    const [isScrollUp, setOnScrollUp] = useState<boolean>(window.scrollY > 50);
    const [isShowMenu, setIsShowMenu] = useState<boolean>(false);
    const isLoggedIn = useIsLoggedIn();
    // page redux
    useEffect(() => {
        dispatch(fetchActiveDiscount());

        if (isLoggedIn) {
            dispatch(fetchCartItems());
        } else {
            const urlParams = new URLSearchParams(window.location.search);
            const urlSessionId = urlParams.get("sessionId");
            if (urlSessionId) {
                dispatch(fetchCartItems(urlSessionId));
            } else if (sessionHelper.hasSession()) {
                const sessionId = sessionHelper.getSessionId();
                dispatch(fetchCartItems(sessionId));
            }
        }
    }, [isLoggedIn, dispatch]);

    const { cartItems, cartItemsLoadingStage } = useAppSelector(selectCheckout);
    const productCount = cartItems?.length || 0;
    const isCartLoading =
        cartItemsLoadingStage === LoadingStage.IS_INITIALIZING ||
        cartItemsLoadingStage === LoadingStage.IS_LOADING;
    // page variable
    const pathName = location.pathname;
    const isHeader = pathName === PATH_HOME;
    const headerFix = pathName === PATH_HOME;

    window.onscroll = () => {
        setOnScrollUp(window.scrollY > 50);
    };

    const handleBackToHome = () => {
        navigate(PATH_HOME);
    };

    const handleToggleShowMenu = () => {
        setIsShowMenu(!isShowMenu);
    };

    if (width >= 767 || isHeader) {
        return (
            <HeaderComponent
                $headerFix={headerFix}
                $isScrollUp={isScrollUp}
                $toggleShowMenu={handleToggleShowMenu}
                $isShowMenu={isShowMenu}
                $productCount={productCount}
                $isCartLoading={isCartLoading}
            />
        );
    }

    return (
        <HeaderNavigatorComponent
            $toggleShowMenu={handleToggleShowMenu}
            $isShowMenu={isShowMenu}
            $onBackToHome={handleBackToHome}
            $productCount={productCount}
            $isCartLoading={isCartLoading}
        />
    );
};
